import React, { forwardRef, HTMLAttributes } from 'react';
import classNames from 'classnames';
import styles from './Card.module.scss';

export interface CardFooterProps extends HTMLAttributes<HTMLDivElement> {}

const CardFooter = forwardRef<HTMLDivElement, CardFooterProps>(
  ({ className, children, ...props }, ref) => (
    <div className={classNames(styles.footer, className)} ref={ref} {...props}>
      {children}
    </div>
  ),
);

CardFooter.displayName = 'Card.Footer';

export default CardFooter;
